import { ProjectsListPage } from "@/components/Projects/ProjectsListPage";

export function Projects() {
  return <ProjectsListPage />;
}
